import React, { Component } from 'react';
import { Icon, Card, Loader, Button, Label, Image, TextArea, Modal,Grid,Input, Divider,Popup} from 'semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import noImage from '../../../../images/common/broken-image.png'
import _ from 'lodash';
import ShowPlaybookMetaDataSchema from '../drive/modals/ShowPlaybookMetaDataSchema'
import AccessControl from './IndesignComponent/AccessControl'
import PlaybookIntegrationConfig from './PlaybookIntegrationConfig';
import DetailsPack from './IndesignComponent/Details'
import SummaryPack from './IndesignComponent/Summary'
import ExportToWord from './IndesignComponent/ExportToWord'
import Contributors from './IndesignComponent/Contributor'
import Tags from './IndesignComponent/Tags'
import ContributorsModal from './../drive/modals/ContributorsModal'
import Accordion from '@zippytech/react-toolkit/Accordion'
import Notes from './IndesignComponent/Notes'
import NotesModal from './../drive/modals/Notes'
import '@zippytech/react-toolkit/Accordion/index.css'
import { toastr } from 'react-redux-toastr';
import AccessControlUpdateModal from "./IndesignComponent/AccessControlUpdateModal"
import { connect } from 'react-redux';
import ImageResizer from './../../../drive/ImageResizer/ImageResizer';
import FileUploader from '../../../drive/Attachments/UppyFileUpload';
import CreateSchema from '../drive/modals/CreateSchema'
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import { Form } from 'formsy-semantic-ui-react';
import objectId from '../../../../helpers/objectId';
import ShowPlaybookMetaData from "../drive/modals/ShowPlaybookMetaData";
import SchemaModalForm from '../../../drive/FormBuilder/SchemaModalForm';
var moment = require('moment');
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class InDesignResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            updatedImage: this.props.selectedPracticeLibrary.picture,
            openNotesModel: false,
            clickStatus: '',
            showInlineDashboard: false,
            openDashboard: false,
            KBOpne: false,
            type: null,
            modalFlag: false,
            schema: null,
            shemaUpdationKey: "",
            metadataSchemaFlag:false,
            editItem: null,
            action: "",
            schemaJSON:false,
            postProcessingModalFlag: false,
            preProcessingModalFlag: false,
        }

        this.editPack = this.editPack.bind(this);
        this.getPlaybookToExport = this.getPlaybookToExport.bind(this);
        this.deletePlaybook = this.deletePlaybook.bind(this);
    }

    componentWillMount() {
        dispatch.lifeCycle.setParticipantsAsync([])
        dispatch.lifeCycle.setInvitedParticipantAsync([]);
        dispatch.lifeCycle.modalRoleChangeOpen(false);
        dispatch.organizationUnit.fetchTeams({ organizationId: this.props.selectedOrganisation.id, accountId: this.props.selectedAccount._id });
        dispatch.integrations.getIntegrationEntities(this.props.selectedOrganisation);
    }

    openImageModal = (open) => {
        if(open && this.props.selectedPracticeLibrary){
            dispatch.lifeCycle.getPlaybookImages({topic:this.props.selectedPracticeLibrary.name})
        }
        this.setState({ open: open })
    }

    notesClick = (open, clickStatus) => {
        this.setState({ openNotesModel: open, clickStatus: clickStatus })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            dispatch.lifeCycle.setPlaybookImagesBuffer([])
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
            let payload = {
                _id: this.props.selectedPracticeLibrary._id,
                picture: imageData.data.secure_url
            }
            dispatch.lifeCycle.updatePlaybookPicture(payload)
        }
    }
    setMetadataSchemaModalFlag = async (flag) => {    
        await dispatch.createPack.setSelectedDataItem(null)
        this.setState({ metadataSchemaFlag: flag, editItem: null, action: "Add"});
      };
    setSchemaJsonFlag = (flag) => {
        this.setState({schemaJSON: flag})
      }
      onSubmitSchema = (schema) =>{
        this.props.selectedPracticeLibrary.metaDataSchema = schema;
        dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
      }
      setItemToEdit = async (data) => {
        this.setState({ editItem: data }, () => {
            this.setState({ metadataSchemaFlag: true, action: "Update"})
        });
      }
      onRemoveItem = (data) => {
        let updateOptions = this.props.selectedPracticeLibrary.metaDataSchema.filter(option => option.name !== data.name)
        let message = <div className="confirmMessage">
            <h3>Delete Metadata Schema</h3>
            <label>{data.title}</label>
            <p>Are you sure to delete this metadata schema?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                // dispatch.lifeCycle.updatePlaybookActivities(updateOptions)
                this.onSubmitSchema(updateOptions)
            }
        });
      }
    editPack() {
        if (this.props.setUpdatedImageName !== null) {
            this.props.selectedPracticeLibrary.picture = this.props.setUpdatedImageName.secure_url;
        }
        if (this.props.participantsData.length !== 0) {
            this.props.selectedPracticeLibrary.participants = this.props.participantsData;
        }
        this.props.selectedPracticeLibrary.updatedAt = new Date();
        let temp = this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.role === 'author' });
        if (temp.length === 1) {
            dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
        }
        else {
            toastr.error('Message', 'Playbook can have only one designer.')
        }

    }

    async getPlaybookToExport() {
        await dispatch.lifeCycle.getPlaybookToExport(this.props.selectedPracticeLibrary._id);
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.props.playbookToExport));
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataStr);
        }
        else {
            //for firfox/chrome
            let link = document.createElement('a');
            link.href = dataStr;
            link.download = this.props.selectedPracticeLibrary.name + '.playbook';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
    deletePlaybook() {
        let message = <div className="confirmMessage">
            <h3>Delete Playbook</h3>
            <label>{this.props.selectedPracticeLibrary.name}</label>
            <p>Are you sure that you wish to delete this Playbook?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let payload = {}
                payload.type = 'removePack';
                payload.packid = this.props.selectedPracticeLibrary._id;
                payload.organizationId = this.props.selectedOrganisation.id;
                payload.userid = this.props.user._id;
                dispatch.lifeCycle.deletePlaybook(payload);
                dispatch.lifeCycle.setArrangementPaneFlag(false);
            }
        });
    }

    handleOpen = () => {
        dispatch.lifeCycle.modalOpen(true);
    }

    saveIntegrationConfigs = (configData) => {
        configData.organizationId = this.props.selectedOrganisation.id,
            configData.accountId = this.props.selectedAccount._id,
            configData.entityId = this.props.selectedPracticeLibrary._id,
            configData.entityName = "playbook"

        dispatch.integrations.addEntityIntegrationConfig(configData);
    }

    handleOpenSchema = (openSchema) => {
        this.setState({ openSchema: openSchema })
    }

    handleUppyModalClick = () => {
        this.setState({
            openDashboard: !this.state.openDashboard
        });
    }

    close = () => {
        this.setState({ linkOpen: false, name: '', url: '' })
    }

    addLink = () => {
        let attachments = this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.attachments ? this.props.selectedPracticeLibrary.attachments : [];
        let document = {};
        document.documentName = this.state.name;
        document.documentId = objectId();
        document.documentUrl = this.state.url;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();
        attachments.unshift(document);
        this.addAttachment(attachments)
        this.close()
    }

    addAttachment = (attachments) => {
        let attachmentPayload = {
            _id: this.props.selectedPracticeLibrary._id,
            name: this.props.selectedPracticeLibrary.name,
            data: {
                attachments: attachments
            }
        }
        dispatch.lifeCycle.updatePlaybook(attachmentPayload);
    }


    handleModalKB = (open, type, page) => {

        this.setState({
            KBOpne: open,
            type: type,
            page: page
        })

    }

    updateCategory = (data) => {
        const history = this.props.history
        let payload = {
            _id: this.props.selectedPracticeLibrary._id,
            name: this.props.selectedPracticeLibrary.name,
            data: {
                baseCategory: data.k,
                category: data.c,
                subCategory: data.s,
            }
        }
        if (data.scope && this.state.type === "scope") {
            payload.data.scope = data.scope === "Private" ? "Public" : "Private"
        }
        dispatch.lifeCycle.updatePlaybook(payload);
        this.setState({ KBOpne: false })

        if (this.state.type === "scope") {
            let setStatus = '';
            let scope = ''
            if (data.scope === "Private") {
                setStatus = 'publicKnowledgeBank'
                scope = "Public"
            } else if (data.scope === "Public") {
                scope = "Private"
                setStatus = 'knowledgeBank'
            }
            history.push({
                pathname: '/app/' + this.props.selectedAccount._id + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/' + setStatus
            });
            dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope });

        }
    }
    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }

    onHandleTag = (tags) => {
        this.props.selectedPracticeLibrary.tags = tags
        dispatch.lifeCycle.editPackAsync({ selectedPack: this.props.selectedPracticeLibrary, user: this.props.user })
    }
    checkForIntegrations = () => {
        if (this.props.selectedOrganisation) {
            if (this.props.integrationEntities) {
                if (this.props.integrationEntities["playbook"]) {
                    if (this.isWorkspaceOwner() || this.isDesigner()) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    isDesigner = () => {
        const loggdinUserId = this.props.user.email;
        let author =
            this.props.selectedPracticeLibrary &&
            this.props.selectedPracticeLibrary.participants &&
            this.props.selectedPracticeLibrary.participants.filter((participant) => {
                return participant.role === "author";
            });
        if (author && author.length > 0) {
            return author.find((author) => author.email === loggdinUserId);
        }
        return null;
    };
    isWorkspaceOwner = () => {
        // const loggdinUserId = this.props.user._id;
        let authors =
            this.props.currentOrganization &&
            this.props.currentOrganization.users &&
            this.props.currentOrganization.users.filter(
                (el) =>
                    el.accountUserId === this.props.user._id &&
                    el.role === "workspaceOwner"
            );
        if (authors && authors.length > 0) {
            return true;
        }
        return null;
    };
    setMetaDataFlag = async (flag, schema, shemaUpdationKey) => {
        await this.setState({ modalFlag: flag, schema: schema, shemaUpdationKey: shemaUpdationKey });
    };
    setPostProcessingFlag = async (flag, schema, shemaUpdationKey) => {
        await this.setState({ postProcessingModalFlag: flag, schema: schema, shemaUpdationKey: shemaUpdationKey });
    };
    setPreProcessingFlag = async (flag, schema, shemaUpdationKey) => {
        await this.setState({ preProcessingModalFlag: flag, schema: schema, shemaUpdationKey: shemaUpdationKey });
    };
    render() {
        let metaDataFlag = false;
        let postProcessingModalFlag = false;
        let preProcessingModalFlag = false;
        const integrationEnabled = this.checkForIntegrations();
        // Below changes for KLM-9602
        // if (this.isWorkspaceOwner() || this.isDesigner()) {
            if(this.props.selectedPracticeLibrary.status === 0) {
                metaDataFlag = true
                postProcessingModalFlag = true
                preProcessingModalFlag = true
            }
            else if(this.props.selectedPracticeLibrary.status === 1 || this.props.selectedPracticeLibrary.status === 2) {
                metaDataFlag = false
                postProcessingModalFlag = false
                preProcessingModalFlag = false
            }
            else {
                metaDataFlag = false
                postProcessingModalFlag = false
                preProcessingModalFlag = false
            }
        // }

        let integrationsForPlaybook = [];
        if (this.props.integrationEntities && this.props.integrationEntities["playbook"]){
            integrationsForPlaybook = [...this.props.integrationEntities["playbook"]];
            if (this.props.entityIntegrationsConfig && this.props.entityIntegrationsConfig.length > 0) {
                integrationsForPlaybook.forEach((integration) => {
                    integration.isDefinedForEntity = false;
                    this.props.entityIntegrationsConfig.forEach((entityConfig) => {
                        if (integration.id == entityConfig.type && integration._id && entityConfig.integrationId) {
                            integration.formData.forEach((item) => {
                                item.value = entityConfig.formData[item.label]
                            });
                            integration.isDefinedForEntity = true;
                            integration.entityIntegrationConfigId = entityConfig._id;
                        }
                    })
                });
            } else {
                integrationsForPlaybook.forEach((integration) => {
                    integration.formData.forEach((item) => {
                        delete item.value;
                    });
                });
            }
        }

        const errorLabel = <div className="customErrorLabel" />;
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let counts = {}

        if (this.props.selectedPracticeLibrary) {
            counts.tagsLength = <Label>{this.props.selectedPracticeLibrary.tags && this.props.selectedPracticeLibrary.tags.length}</Label>
            counts.attachmentsLength = <Label>{this.props.selectedPracticeLibrary.attachments && this.props.selectedPracticeLibrary.attachments.length}</Label>
            counts.notesLength = <Label>{this.props.selectedPracticeLibrary.notes && this.props.selectedPracticeLibrary.notes.length}</Label>
            counts.participantsLength = <Label>{this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length}</Label>
        }
        let isAuthorizedToAdd = false;
        this.props.selectedAccount && this.props.selectedAccount.users && this.props.selectedAccount.users.map(user => {
            let customerAdminsId = user.id && user.id._id ? user.id._id : user.id;
            if ((customerAdminsId && customerAdminsId.toString() === this.props.user && this.props.user._id.toString()) && user.role === "customerAdmin") {
                isAuthorizedToAdd = true;
            }
        });

        if (!isAuthorizedToAdd) {
            if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.createdBy && this.props.user._id.toString() === this.props.selectedPracticeLibrary.createdBy.toString()) {
                isAuthorizedToAdd = true;
            }
        }
        return (

            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    {!_.isEmpty(this.props.selectedPracticeLibrary) ?
                        <Accordion
                            expandTool={expandTool}
                            horizontal
                            enableKeyboardNavigation={false}>
                            {[
                                <div tabTitle="Overview">
                                    <div className="acc-header">Overview</div>
                                    <div className="resourcePaneOverflow">
                                        <DetailsPack selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            user={this.props.user} playbookError={this.props.playbookError} />
                                    </div>

                                </div>,
                                <div tabTitle={<div>Team and Participants {counts.participantsLength} </div>}>
                                    <div className="resourcePaneOverflow">
                                        <div className="acc-header">Team and Participants {counts.participantsLength}
                                            {this.props.selectedPracticeLibrary.status === 0 && isAuthorizedToAdd &&
                                                <Icon name='plus' className="cursor-pointer" color='green' onClick={this.handleOpen} />
                                                 }
                                                 <Popup
                                                 trigger={<Icon name="info icon blue circle" size="large"/>}
                                                 content=" You will be able to add members within the team only"
                                                 basic
                                                 position='right center'
                                                 wide
                                                 /></div>
                                        <ContributorsModal
                                            isEditModalOpen={this.props.isEditModalOpen}
                                            isModalOpen={this.props.isModalOpen}
                                            searchUserArr={this.props.searchUserArr}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            userSearchObject={this.props.userSearchObject}
                                            participantsData={this.props.selectedPracticeLibrary.participants}
                                            status={this.props.selectedPracticeLibrary.status}
                                            showResourecePaneFlag={this.props.showResourecePaneFlag}
                                            invitedUsersArray={this.props.invitedUsersArray}
                                            user={this.props.user}
                                            searchInviteUserArr={this.props.searchInviteUserArr}
                                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            accountId={this.props.selectedAccount._id}
                                            workspaceId={this.props.selectedOrganisation.id}
                                        />
                                        <Contributors
                                            isInDesign={true}
                                            teamList={this.props.teamList}
                                            isRoleChangeModalOpen={this.props.isRoleChangeModalOpen}
                                            status={this.props.selectedPracticeLibrary.status}
                                            showResourecePaneFlag={this.props.showResourecePaneFlag}
                                            invitedUsersArray={this.props.invitedUsersArray}
                                            playbookInvitaions={this.props.playbookInvitaions}
                                            isPlaybookInvitationModalOpen={this.props.isPlaybookInvitationModalOpen}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            organizationId={this.props.organizationId}
                                            user={this.props.user}
                                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            selectedAccount={this.props.selectedAccount}
                                        />
                                    </div>

                                </div>,
                                <div tabTitle={<div>Comments {counts.notesLength} </div>}>
                                    <div className="acc-header">Comments {counts.notesLength}

                                        {(this.props.selectedPracticeLibrary.status === 0 || this.props.selectedPracticeLibrary.status === 1 || this.props.selectedPracticeLibrary.status === 2 || this.props.selectedPracticeLibrary.status === 3)
                                            && <Icon name='plus' className="cursor-pointer" color='green' onClick={() => this.notesClick(true, "addNote")} />

                                        }
                                    </div>
                                    <div>
                                        <Notes
                                            notes={this.props.selectedPracticeLibrary.notes}
                                            user={this.props.user}
                                            notesClick={this.notesClick}
                                            status={this.props.selectedPracticeLibrary.status}
                                            selectedData={this.props.selectedPracticeLibrary}
                                            arrangementPaneActiveButtonFlag={this.props.arrangementPaneActiveButtonFlag}
                                            string='indesignPlaybook'
                                            role={this.props.selectedOrganisation.role}
                                        />
                                    </div>
                                </div>,
                                <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
                                    <div className="acc-header"> Attachments {counts.attachmentsLength}
                                        {/* {
                                    this.props.selectedPracticeLibrary.status === 0 ? 
                                    <Icon name='plus' id="modalButton" className="cursor-pointer" color='green' onClick={this.handleUppyModalClick} /> 
                                    : null } */}
                                        {this.props.selectedPracticeLibrary.status === 0 ?
                                            <span className="pull-right" style={{ margin: "4px 0px" }}>
                                                <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Upload File' onClick={this.handleUppyModalClick} />
                                                <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Add Link' onClick={() => this.setState({ linkOpen: true })} />
                                            </span>
                                            : null}
                                    </div>
                                    <FileUploader
                                        data={this.props.selectedPracticeLibrary}
                                        action={this.addAttachment}
                                        openDashboard={this.state.openDashboard}
                                        handleUppyModalClick={this.handleUppyModalClick}
                                        entityName="playbook"
                                        playbookStatus={this.props.selectedPracticeLibrary.status}
                                        selectedOrganization={this.props.selectedOrganisation}
                                        selectedPlaybook={this.props.selectedPracticeLibrary}
                                        to='playbook'
                                        status={this.props.selectedPracticeLibrary.status}
                                    />

                                </div>,
                                <div tabTitle={<div>Publishing / Category
                                    {/* &nbsp; {this.props.selectedPracticeLibrary.baseCategory === "" ?
                                    <Icon className="clr-red" name='exclamation triangle' /> : null} */}
                                </div>}>
                                    <div className="acc-header">Publishing / Category</div>
                                    <div className="resourcePaneOverflow">
                                        <AccessControl
                                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            selectedAccount={this.props.selectedAccount}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            user={this.props.user}
                                            scope={this.props.selectedPracticeLibrary.scope}
                                            baseCategory={this.props.selectedPracticeLibrary.baseCategory}
                                            category={this.props.selectedPracticeLibrary.category}
                                            subCategory={this.props.selectedPracticeLibrary.subCategory}
                                            handleModalKB={this.handleModalKB} />

                                        <AccessControlUpdateModal
                                            baseCategoriesArr={this.props.baseCategoriesArr}

                                            status={this.props.selectedPracticeLibrary.status}
                                            user={this.props.user}
                                            publicCategoryList={this.props.publicCategoryList}
                                            handleModalKB={this.handleModalKB}
                                            updateCategory={this.updateCategory}
                                            open={this.state.KBOpne}
                                            type={this.state.type}
                                            page={this.state.page}
                                            scope={this.props.selectedPracticeLibrary.scope}
                                            baseCategory={this.props.selectedPracticeLibrary.baseCategory}
                                            category={this.props.selectedPracticeLibrary.category}
                                            subCategory={this.props.selectedPracticeLibrary.subCategory}
                                            selectedAccount={this.props.selectedAccount}
                                        />


                                    </div>
                                </div>,
                                <div tabTitle={<div>Tags {counts.tagsLength}</div>}>
                                    <div className="acc-header">Tags {counts.tagsLength}</div>
                                    <div className="resourcePaneOverflow">
                                        <Form
                                            noValidate
                                        >
                                            <Tags
                                                module="playbook"
                                                tags={this.props.selectedPracticeLibrary.tags}
                                                onHandleTag={this.onHandleTag}
                                                editAccess={this.props.selectedPracticeLibrary.status === 0}
                                            />
                                        </Form>
                                    </div>
                                </div>,

                                <div tabProps={{ title: 'Image ' }} onMouseEnter={() => dispatch.app.setHelpContext("Image Card")}>
                                    <div className="acc-header">Image </div>
                                    <div className="resourcePaneOverflow">
                                        <Card className="organizationCard" >
                                            <Card.Content >
                                                <div >
                                                    <Loader active={this.state.loader} />
                                                    <Image onError={this.addDefaultSrc} src={this.state.updatedImage} className="fitImage" alt="Playbook Image" />
                                                    {this.props.selectedPracticeLibrary.status === 0 ?
                                                        <Button type="button" className="circular_24_icon first-rectangle-image" icon='pencil' onClick={() => this.openImageModal(true)} />
                                                        : null}
                                                </div >
                                            </Card.Content>
                                        </Card>
                                        <ImageResizer
                                            image={this.state.updatedImage}
                                            openImageModal={this.openImageModal}
                                            cloudinaryImage={this.cloudinaryImage}
                                            playbookImagesBuffer={this.props.playbookImagesBuffer}
                                            loadingImages={this.props.playbookImagesLoading}
                                            open={this.state.open}
                                            envData={this.props.envData}
                                            width={504}
                                            height={280}
                                        />
                                    </div>
                                </div>,
                                (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'workspaceOwner') || (this.props.selectedPracticeLibrary.participants &&
                                    this.props.selectedPracticeLibrary.participants.filter(user => user.accountUserId.toString() === this.props.user._id.toString() && user.role === 'author').length > 0) ? < div tabProps={{ title: 'Export Setting' }}>
                                    <div className="acc-header">Export Setting

                                    </div>
                                    <div className="resourcePaneOverflow">
                                        <ExportToWord
                                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            currentPlaybookTemplate={this.props.currentPlaybookTemplate}
                                            user={this.props.user}
                                        />
                                    </div>

                                </div> : null,
                                integrationEnabled && integrationsForPlaybook.length > 0 ? < div tabProps={{ title: 'Integrations' }}>
                                    <div className="acc-header">Integrations
                                    </div>
                                    <div className="resourcePaneOverflow">
                                        <PlaybookIntegrationConfig configData={integrationsForPlaybook} onSave={this.saveIntegrationConfigs} />
                                    </div>

                                </div> : null,
                                <div tabProps={{ title: 'Summary' }}>
                                    <div className="acc-header">Summary</div>
                                    <div className="resourcePaneOverflow">
                                        <SummaryPack selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                            participantsData={this.props.participantsData}
                                        />
                                    </div>

                                </div>,
                                <div tabProps={{ title: "MetaData Schema" }}>
                                <div className="acc-header">
                                  MetaData Schema 
                                  <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                    {(metaDataFlag && this.props.selectedPracticeLibrary) ? (
                                        <Button
                                        disabled={!metaDataFlag}
                                        content="Edit JSON Schema"
                                        className="button-submit float-right "
                                        type="button"
                                        onClick={() => this.setSchemaJsonFlag(true)}
                                        />
                                    ) : null}
                                   {(metaDataFlag && this.props.selectedPracticeLibrary) ? (
                                        <Button
                                        disabled={!metaDataFlag}
                                        content="Add Schema"
                                        className="button-submit float-right "
                                        type="button"
                                        onClick={() => this.setMetadataSchemaModalFlag(true)}
                                        />
                                    ) : null}
                                  </span>
                                </div>
                                {this.props.selectedPracticeLibrary &&
                                this.props.selectedPracticeLibrary.metaDataSchema && this.props.selectedPracticeLibrary.metaDataSchema.length > 0 ? (
                                  <div className="resourcePaneOverflow">
                                    <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={7}>
                                            <div className='acc-header'>Name Field</div>
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <div className='acc-header'>Type</div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    {this.props.selectedPracticeLibrary.metaDataSchema.map((m) => {
                                        return (
                                        <Grid.Row style={{ 'margin-bottom': '5px' }}>
                                            <Grid.Column width={7}>
                                            <Input style={{width: "180px"}} disabled placeholder="Title" value={m.title} />
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <Input style={{width: "180px"}} disabled placeholder="Text Box" value={m.type} />
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                            <Button icon="edit alternate" className="trash-color" onClick={() => this.setItemToEdit(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>
                                        </Grid.Column>
                                        <Grid.Column width={1}>
                                            <Button icon="trash alternate" className="trash-color" onClick={() => this.onRemoveItem(m)} style={{ 'background': 'white', 'padding': '5px', 'margin-top': '4px' }}></Button>
                                        </Grid.Column>
                                        </Grid.Row>
                                        )
                                    })}
                                </Grid>
                                  </div>
                                ) : <span className="clr-orange">No metaData to display</span>}
                              </div>,
                                <div tabProps={{ title: "MetaData" }}>
                                    <div className="acc-header">
                                        MetaData
                                        <span
                                            style={{ margin: "0 20px" }}
                                            className="clr-gray fs_italic"
                                        >
                                            {(metaDataFlag) ? (
                                                <Button
                                                    disabled={!metaDataFlag}
                                                    content="Edit"
                                                    className="button-submit float-right "
                                                    type="button"
                                                    onClick={() => this.setMetaDataFlag(true, this.props.selectedPracticeLibrary.metaData, "metaData")}
                                                />
                                            ) : null}
                                        </span>
                                    </div>
                                    {this.props.selectedPracticeLibrary &&
                                        this.props.selectedPracticeLibrary.metaData ? (
                                        <div className="resourcePaneOverflow">
                                            <pre>
                                                {JSON.stringify(
                                                    this.props.selectedPracticeLibrary.metaData,
                                                    null,
                                                    2
                                                )}
                                            </pre>
                                        </div>
                                    ) : <span className="clr-orange">No metaData to display</span>}
                                </div>,
                            ].filter(elem => !!elem)}


                        </Accordion> : null}
                    <NotesModal
                        notes={this.props.selectedPracticeLibrary.notes}
                        selectedData={this.props.selectedPracticeLibrary}
                        user={this.props.user}
                        open={this.state.openNotesModel}
                        clickStatus={this.state.clickStatus}
                        notesClick={this.notesClick}
                        currentNote={this.props.currentNote}
                        string='indesignPlaybook' />

                    {this.state.openSchema ?
                        <CreateSchema
                            openSchema={this.state.openSchema}
                            handleOpenSchema={this.handleOpenSchema}
                            selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                        /> : null}

                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.name}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.url}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ url: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Add Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal>
                </div>
                <ShowPlaybookMetaData
                    open={this.state.modalFlag}
                    setMetaDataFlag={this.setMetaDataFlag}
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    metaDataSchema={
                        this.state.schema
                    }
                    view="playbook"
                    shemaUpdationKey={this.state.shemaUpdationKey}
                />
                <ShowPlaybookMetaDataSchema
                    open={this.state.schemaJSON}
                    setMetaDataFlag={this.setSchemaJsonFlag}
                    metaDataSchema={this.props.selectedPracticeLibrary.metaDataSchema}
                    onSubmitSchema={this.onSubmitSchema}
                 />
                {this.state.metadataSchemaFlag &&
                    <SchemaModalForm
                        open={this.state.metadataSchemaFlag}
                        close={this.close}
                        schemaOpen={this.setMetadataSchemaModalFlag}
                        onSubmitSchema={this.onSubmitSchema}
                        schema={this.props.selectedPracticeLibrary.metaDataSchema}
                        selectedItem={this.state.editItem}
                        action={this.state.action}
                    /> }
            </div >
        )
    }
}
function mapStateToProps(state) {
    return {
        accessToken: state.login.accessToken,
        envData: state.app.envData,
        integrationEntities: state.integrations.integrationEntities,
        entityIntegrationsConfig: state.integrations.entityIntegrationsConfig,
        currentPlaybookTemplate: state.lifeCycle.currentPlaybookTemplate,
        teamList: state.organizationUnit.teamList,
    };
}
const inDesignPlaybookPage = connect(mapStateToProps)(InDesignResourcePane);

export default inDesignPlaybookPage;



